import { render, staticRenderFns } from "./appeal.vue?vue&type=template&id=840c9358&"
import script from "./appeal.vue?vue&type=script&lang=js&"
export * from "./appeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports